import React from 'react';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import MenuSectionGrid from 'components/Menu/MenuSectionGrid';
import MenuItemCardSkeleton from 'bento-ordering/menus/components/MenuItemCardSkeleton';

const MenuSectionHeaderSkeleton = () => {
  return <Skeleton variant="rectangular" width={83} height={22} />;
};

const MenuSectionSkeleton = () => (
  <>
    <Box mb="20px">
      <MenuSectionHeaderSkeleton />
    </Box>
    <MenuSectionGrid>
      {[...Array(6).keys()].map((_, index) => (
        <MenuItemCardSkeleton key={index} />
      ))}
    </MenuSectionGrid>
  </>
);

export default MenuSectionSkeleton;
